import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";
import { AuthGuardService } from "@/shared/auth-guard.service";
import { EntityManagerProviderGuard } from "@/shared/entity-manager-guard";
import { SharedModule } from "@/shared/shared.module";
import { CancelLineComponent } from "./cancel-line.component";
import { FillFromInventoryComponent } from "./fill-from-inventory.component";
import { OrderFacilitationManagerComponent } from "./order-facilitation-manager.component";
import { PendingCancellationsTrayComponent } from "./pending-cancellations-tray.component";
import { ReassignFromAnotherJoComponent } from "./reassign-from-another-jo.component";
import { SubstitutionConfirmDialogComponent } from "./substitution-confirm-dialog.component";

export const routes: Routes = [
  {
    path: "order-facilitation/manage",
    component: OrderFacilitationManagerComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { breadcrumb: "Order Facilitation" },
    children: [
      {
        path: "",
        redirectTo: "fill-from-inventory",
        pathMatch: "full",
      },
      {
        path: "fill-from-inventory",
        component: FillFromInventoryComponent,
        data: { breadcrumb: "Fill from Inventory" },
      },
      {
        path: "reassign-from-another-jo",
        component: ReassignFromAnotherJoComponent,
        data: { breadcrumb: "Reassign from Another JO" },
      },
      {
        path: "cancel-line",
        component: CancelLineComponent,
        data: { breadcrumb: "Cancel Order Details" },
      },
    ],
  },
];

@NgModule({
  declarations: [
    OrderFacilitationManagerComponent,
    CancelLineComponent,
    FillFromInventoryComponent,
    PendingCancellationsTrayComponent,
    ReassignFromAnotherJoComponent,
    SubstitutionConfirmDialogComponent,
  ],
  imports: [SharedModule],
})
export class OrderFacilitationModule {}
